import angular from 'angular';
import display from './builder/display.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/htmlelement/display.html', display);
});
